// src/context/UserImageContext.js
import React, { createContext, useEffect, useState } from "react";

export const UserImageContext = createContext();

export const UserImageProvider = ({ children }) => {
  const [userImage, setUserImage] = useState(null);

  // Load image from localStorage on mount
  useEffect(() => {
    const storedImage = localStorage.getItem("user_image");
    if (storedImage) {
      setUserImage(storedImage);
    }
  }, []);

  // Update localStorage when image changes
   const updateUserImage = (newImageUrl) => {
    setUserImage(newImageUrl);
    localStorage.setItem("user_image", newImageUrl);
  };

  return (
    <UserImageContext.Provider value={{ userImage, updateUserImage }}>
      {children}
    </UserImageContext.Provider>
  );
};
